module.exports = __webpack_public_path__ + "static/media/logo_ibracor.1828a32d.jpeg";